<template>
  <div>
    <video-background
      :src="introVideo"
      style="max-height: 400px; height: 100vh"
    >
    </video-background>
    <v-container black fluid>
      <section>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm5>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Bio</div>
              </v-card-title>
              <v-card-text>
                <p>
                  An unsettling electronic duo from the serene shores of Loch
                  Lomond and the remote Outer Hebridean Isles. Witch of the Vale
                  released their debut album
                  <a
                    target="_blank"
                    href="https://witchofthevale.bandcamp.com/album/commemorate-2"
                  >
                    Commemorate
                  </a>
                  in December 2020 with
                  <a target="_blank" href="http://cleorecs.com/home/"
                    >Cleopatra Records</a
                  >
                  . They have also since been featured in the official movie
                  soundtracks for
                  <a
                    target="_blank"
                    href="https://cleorecs.com/store/shop/baphomet-dvd-or-blu-ray"
                    >Baphomet</a
                  >
                  ,
                  <a
                    target="_blank"
                    href="https://www.youtube.com/watch?v=aNZQLC77KuI"
                    >Scavenger</a
                  >
                  , and
                  <a
                    target="_blank"
                    href="https://cleorecs.com/products/cocaine-werewolf-dvd-or-blu-ray"
                    >Cocaine Werewolf</a
                  >
                  . 2024 saw the release of
                  <a
                    target="_blank"
                    href="https://witchofthevale.bandcamp.com/album/100-ways-to-leave"
                    >100 Ways to Leave</a
                  >, followed by
                  <a
                    target="_blank"
                    href="https://witchofthevale.bandcamp.com/album/lovesongs-for-the-damned-digital-copy-only"
                    >Lovesongs for the Damned</a
                  >
                  in 2026.
                </p>
                <br />

                <p>
                  Witch of the Vale began creating music together after
                  identifying a shared love of a particular style of dark,
                  melodic music which they felt was missing from the current
                  scene. Having taught themselves how to record, mix and
                  engineer their own unique sound, the first song they wrote
                  together
                  <a
                    target="_blank"
                    href="https://open.spotify.com/track/2zwPqAk9LfsM7jyj6YUIYg"
                  >
                    Trust the Pain</a
                  >
                  would go on to be ranked one of the top electronic tracks of
                  2019 by
                  <a
                    target="_blank"
                    href="http://www.electricityclub.co.uk/the-electricity-clubs-30-songs-of-2019/"
                  >
                    The Electricity Club</a
                  >
                  and
                  <a
                    target="_blank"
                    href="http://www.amodelofcontrol.com/countdown/6762/"
                    >amodelofcontrol</a
                  >
                  and remixed by Leæther Strip.<br />
                  Their debut album released in December 2020 to critical
                  acclaim, went on to reach number 1 on both the gothic and the
                  industrial music charts on BandCamp.
                </p>
                <br />

                <section class="hidden-sm-and-down">
                  <br />
                </section>
                <p>
                  Witch of the Vale have become well established in the UK goth
                  industrial scene and made their debut festival appearance in
                  August 2019 at
                  <a
                    target="_blank"
                    href="https://infestuk.com/2019/02/15/infest-2019-witch-of-the-vale-confirmed/"
                    >Infest UK</a
                  >
                  . They have opened for iconic artists such as Fields of the
                  Nephilim, The Birthday Massacre, Clan of Xymox, Assemblage 23,
                  Solar Fake, Leaether Strip, Drab Majesty, and She Past Away.
                </p>
                <br />

                <p>
                  <i>
                    <quote
                      >"Thank you for an absolutely stunning show at Infest -
                      still a little overwhelmed by your performance -
                      breathtaking." - Infest Mark
                    </quote>
                  </i>
                  <br />
                </p>
                <br />

                <section class="hidden-sm-and-down">
                  <br />
                </section>
                <p>
                  Witch of the Vale are best identified by their haunting vocal
                  style coupled with harmonic synths. These in turn are starkly
                  contrasted by deep drones and abrasive drums. Paired with
                  sincere and melancholic lyrics, their sound is at once
                  ethereal and devastating. Praised for their compelling and
                  tortured live performances, Witch of the Vale’s sound easily
                  compliments more energetic artists, providing a tempo break in
                  line-ups to deliver an atmospheric and deeply emotional
                  experience.
                </p>

                <section class="hidden-sm-and-down">
                  <br />
                </section>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm5 offset-sm1>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">
                  Music
                  <v-btn
                    flat
                    icon
                    v-on:click="
                      goUrl(
                        'https://open.spotify.com/artist/7axp614rqaTEKnaeQJ8F3V',
                      )
                    "
                  >
                    <v-icon>volume_up</v-icon>
                  </v-btn>
                </div>
              </v-card-title>
              <v-layout row wrap align-content-center>
                <v-flex class="hidden-sm-and-down">
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube-nocookie.com/embed/kU1JtAi5G5k"
                    title="YouTube video player"
                    frameborder="0"
                    allow="
                      accelerometer;
                      autoplay;
                      clipboard-write;
                      encrypted-media;
                      gyroscope;
                      picture-in-picture;
                    "
                    allowfullscreen
                  ></iframe>
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube-nocookie.com/embed/8YqecrIhRWY"
                    title="YouTube video player"
                    frameborder="0"
                    allow="
                      accelerometer;
                      autoplay;
                      clipboard-write;
                      encrypted-media;
                      gyroscope;
                      picture-in-picture;
                    "
                    allowfullscreen
                  ></iframe>
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube-nocookie.com/embed/pkfdIwpRfOQ?start=6"
                    title="YouTube video player"
                    frameborder="0"
                    allow="
                      accelerometer;
                      autoplay;
                      clipboard-write;
                      encrypted-media;
                      gyroscope;
                      picture-in-picture;
                    "
                    allowfullscreen
                  ></iframe>
                </v-flex>
                <v-flex class="hidden-md-and-up">
                  <iframe
                    width="280"
                    height="157"
                    src="https://www.youtube-nocookie.com/embed/kU1JtAi5G5k"
                    title="YouTube video player"
                    frameborder="0"
                    allow="
                      accelerometer;
                      autoplay;
                      clipboard-write;
                      encrypted-media;
                      gyroscope;
                      picture-in-picture;
                    "
                    allowfullscreen
                  ></iframe>
                  <iframe
                    width="280"
                    height="157"
                    src="https://www.youtube-nocookie.com/embed/8YqecrIhRWY"
                    title="YouTube video player"
                    frameborder="0"
                    allow="
                      accelerometer;
                      autoplay;
                      clipboard-write;
                      encrypted-media;
                      gyroscope;
                      picture-in-picture;
                    "
                    allowfullscreen
                  ></iframe>
                  <iframe
                    width="280"
                    height="157"
                    src="https://www.youtube-nocookie.com/embed/pkfdIwpRfOQ?start=6"
                    title="YouTube video player"
                    frameborder="0"
                    allow="
                      accelerometer;
                      autoplay;
                      clipboard-write;
                      encrypted-media;
                      gyroscope;
                      picture-in-picture;
                    "
                    allowfullscreen
                  ></iframe>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </section>

      <section>
        <v-carousel style="margin-top: 45px">
          <v-carousel-item
            v-for="(item, i) in images"
            :key="i"
            :src="item.src"
          ></v-carousel-item>
        </v-carousel>
      </section>

      <section>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm5>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Reviews</div>
              </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <em>Infest Mark - </em>
                  <i>
                    Thank you for an absolutely stunning show at Infest - still
                    a little overwhelmed by your performance - breathtaking.</i
                  >
                </v-container>
                <!-- https://epitomeofepic.wordpress.com/2019/08/29/festival-review-infest-2019-23-25-08 -->
                <v-container fluid>
                  <em>The Electricity Club - </em>
                  <i>
                    Erin and Coire Hawthorne sound are like nothing else within
                    the world of modern electronica.</i
                  >
                </v-container>
                <!-- http://www.electricityclub.co.uk/the-electricity-clubs-30-songs-of-2019/ -->

                <v-container fluid>
                  <em>A Mode of Control - </em>
                  <i>
                    The breakout stars of Infest this year – stealing the show
                    from opening the Saturday is some feat – Witch of the Vale
                    sound like no-one else.</i
                  >
                </v-container>
                <!-- http://www.amodelofcontrol.com/countdown/6762/ -->

                <v-container fluid>
                  <em>Epitome of Epic - </em>
                  <i>
                    The entire set wasn’t just a show, it was an experience, and
                    an enchantingly haunting one at that. The music was that
                    powerful that I literally had goosebumps, it was truly
                    stunning.</i
                  >
                </v-container>
                <!-- https://epitomeofepic.wordpress.com/2019/08/29/festival-review-infest-2019-23-25-08/ -->
                <v-container fluid>
                  <em>Brutal Resonance - </em>
                  <i>
                    Erin’s crystal-clear voice and Coire’s piano melodies are
                    utterly enchanting and devastating in songs like ‘The Ghosts
                    Won’t Know’, and it’s one of several moments that causes the
                    room to fall silent and listen in awe...
                  </i>
                </v-container>
                <!-- https://www.brutalresonance.com/feature/linea-aspera-witch-of-the-vale-and-soft-riot-ivory-blacks-10-01-20/ -->

                <v-container fluid>
                  <em>IGI.GS - </em>
                  <i>
                    Erin’s crystal clear vocals flit between haunting and
                    heart-breaking, very much putting me in mind of Hope
                    Sandoval or Liz Fraser from the Cocteau Twins.
                  </i>
                </v-container>
                <!-- https://invernessgigs.co.uk/2019/05/18/live-review-outsider-arts-festival-mad-hatters/ -->
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm5 offset-sm1>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Recommendations</div>
              </v-card-title>
              <v-card-text>
                <div class="text-xs-center">
                  <v-container dense>
                    <i
                      >This is the best thing I've heard in a very long time.</i
                    >
                  </v-container>
                  <v-container dense>
                    <i
                      >Mixing elements of Goth, folk, electronica and world into
                      something dark, disturbing and utterly brilliant. I love
                      it!
                    </i>
                  </v-container>
                  <v-container dense>
                    <i>One of the best albums I've ever heard.</i>
                  </v-container>
                  <v-container dense>
                    <i
                      >This album is full of memorable lyrics that are going to
                      live rent free in my head for years to come. Every song on
                      Commemorate has at least one epic mic-drop moment of
                      stunning lyrics that has me replaying the song over and
                      over again just to hear that line sung again. I hear words
                      I wish I could have said when I was hurting, and now find
                      power and catharsis in on the other side. My favorite
                      album of 2020.</i
                    >
                  </v-container>

                  <v-container dense>
                    <i
                      >Mixing elements of Goth, folk, electronica and world into
                      something dark, disturbing and utterly brilliant. I love
                      it!
                    </i>
                  </v-container>

                  <v-container dense>
                    <i
                      >An amazing debut full length LP; mysterious and brooding
                      and weighty. Brilliantly menacing atmospheric music with
                      incredibly haunting vocals. Among the very best releases
                      of 2020, looking forward to whatever direction the project
                      takes going forward.</i
                    >
                  </v-container>

                  <v-container dense>
                    <i
                      >One of the albums where I can pick any song as a
                      favorite. The music is like beautiful mountain valley and
                      the voice is the river winding its way through and you
                      know Grendel is somewhere around too.
                    </i>
                  </v-container>

                  <v-container dense>
                    <i
                      >Beautiful, ethereal and spine tinglingly awesome
                      music!</i
                    >
                  </v-container>

                  <v-container dense>
                    <i>I fell in love with their music 💖💖</i>
                  </v-container>

                  <v-container dense>
                    <i
                      >The foreboding beauty of this dark electronic due is
                      truly awe-inspiring.</i
                    >
                  </v-container>

                  <v-container dense>
                    <i
                      >beautifully haunting with deep deep feeling, so
                      moving!!!!.</i
                    >
                  </v-container>

                  <v-container dense>
                    <i
                      >Ethereal vocals lead you down the path they weave.
                      Accompanied by hypnotic rhythms played by the stag.
                      Probably the closest thing musically to Alice going
                      through the looking glass</i
                    >
                  </v-container>

                  <v-container dense>
                    <i
                      >You have a presence on stage, you just 'look and sound'
                      amazing! Erin's voice is just, wow! You were so lovely and
                      kind towards me (Coire offered me his seat and asked if
                      would like to join you guys) when I introduced myself.</i
                    >
                  </v-container>

                  <v-container dense>
                    <i
                      >Erin`s voice is haunting and goes straight to the heart,
                      the first time I saw them live I literally cried for the
                      whole of their set.</i
                    >
                  </v-container>

                  <v-container dense>
                    <i
                      >Hauntingly beautiful vocals. Smooth fusion of perfection
                      in musical talent.</i
                    >
                  </v-container>

                  <v-container dense>
                    <i
                      >The Cranes meets Heilung, but using electronic noises. It
                      was gorgeous.</i
                    >
                  </v-container>

                  <v-container dense>
                    <i
                      >beautiful haunting melodic voice, over darkly atmospheric
                      synths and drums. Funeral Pop at its very best.</i
                    >
                  </v-container>

                  <v-container dense>
                    <i>Beautiful voice awesome music</i>
                  </v-container>

                  <v-container dense>
                    <i>Quite simply superb.</i>
                  </v-container>

                  <v-container dense>
                    <i>this music is what was missing for far too long</i>
                  </v-container>

                  <v-container dense>
                    <i
                      >Hypnotic, soul touching siren songs that haunt you,
                      bewitch you, envelop your mind and call you deeper in to
                      the Vale.</i
                    >
                  </v-container>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </section>
    </v-container>
  </div>
</template>

<style scoped>
a {
  color: #ff0000;
}
i {
  color: #888888;
}

.container.dense {
  padding: 12px;
}
</style>

<script>
export default {
  name: "gallery",
  methods: {
    goUrl: function (link) {
      if (link) {
        const win = window.open(link, "_blank", "modal=no");
        win.focus();
      }
    },
  },
  data() {
    return {
      introVideo: require("@/assets/intro-scaled.mp4"),
      rating: 5,
      drawer: null,
      items: [
        { title: "Home", icon: "dashboard" },
        { title: "About", icon: "question_answer" },
      ],
      right: null,
      images: [
        {
          src: require("../assets/carousel/image1.jpg"),
        },
        {
          src: require("../assets/carousel/image2.jpg"),
        },
        {
          src: require("../assets/carousel/image3.jpg"),
        },
        {
          src: require("../assets/carousel/image4.jpg"),
        },
        {
          src: require("../assets/carousel/image5.jpg"),
        },
      ],
    };
  },
};
</script>
